var AdminPolicy = /** @class */ (function () {
    function AdminPolicy() {
    }
    AdminPolicy.prototype.canDrag = function (item) {
        return true;
    };
    AdminPolicy.prototype.canDrop = function (item, target) {
        return true;
    };
    return AdminPolicy;
}());
var policy = new AdminPolicy();
export default policy;



//////////////////
// WEBPACK FOOTER
// ./src/services/DragDropPolicy/AdminPolicy.ts
// module id = 344
// module chunks = 0